const y = (e, n) => e ?? n, S = (e, n) => e || n;
function v(e) {
  return e.endsWith("/") ? e : `${e}/`;
}
function D(e, n, t) {
  return e && e[n] && e[n][t] || [];
}
function L(e, n) {
  return e[n] || [];
}
function h(e, n) {
  return e.length === n.length;
}
function $() {
  const e = /* @__PURE__ */ new WeakMap();
  return function(t, r) {
    e.has(t) && clearTimeout(e.get(t));
    const o = setTimeout(() => {
      e.delete(t), t();
    }, r);
    e.set(t, o);
  };
}
const b = (e = 0, n) => {
  const t = setTimeout(() => {
    n();
  }, e);
  return () => (clearTimeout(t), n());
}, A = () => {
}, I = (e) => {
  const n = e.toLowerCase().replace(/\//g, "-").replace(/ /g, "-");
  return encodeURIComponent(n);
}, N = (e) => {
  let n;
  return e instanceof Error ? n = e.message : e instanceof Response ? n = `${e.status} ${e.statusText}` : n = JSON.stringify(e), n;
}, R = (e, n, t) => e && n && n[t] ? `${e}${n[t]}` : void 0, l = {
  STARTED: "STARTED",
  FINISHED: "FINISHED",
  NOT_STARTED: "NOT_STARTED"
}, s = (e) => e === l.NOT_STARTED, d = (e, n, t) => {
  var o;
  const r = (o = n == null ? void 0 : n.live) == null ? void 0 : o[0];
  if (!(!r || !t || s(e)))
    return r;
}, f = (e, n, t) => {
  if (!(!n || !t || !s(e)))
    return n;
}, w = ({
  eventStatus: e,
  statistics: n,
  isPlayerScoresEnabled: t,
  participantStatistic: r,
  isPlayerStatsEnabled: o
}) => d(e, n, t) || f(e, r, o);
function C(e, n, t) {
  return e ? [t, n] : [n, t];
}
const k = (e, n, t) => {
  if (!e || !n || !t)
    return;
  const r = new URLSearchParams(t);
  return new URL(`${e}v1/teams/${n}/image?${r}`);
};
function* U(e, n) {
  let t = 0, r = 1, o;
  for (; e > 0; )
    o = r, r = r + t, t = o, e--, yield t * n;
}
function c(e, n) {
  return (e == null ? void 0 : e.some((t) => t.toLowerCase() === n.toLowerCase())) || !1;
}
function m(e, n) {
  return e.isEnabled && c(n, "PrePack");
}
function p(e, n) {
  return e.isLiveEnabled && c(n, "LivePrePack");
}
function F(e, n) {
  return m(e, n) || p(e, n);
}
const B = (e, n) => {
  const { sameGameParlayConfig: t } = e;
  return t.isEnabled && n.includes("SportcastBetBuilder") || t.isInHouseEnabled && n.includes("SGP");
};
function O(e) {
  return e !== void 0;
}
const G = (e) => !!e && typeof e == "object" && "errorStatus" in e;
function g(e) {
  return typeof e == "number" || typeof e == "string";
}
function V(e, n) {
  return e && n(e);
}
const _ = (e) => T.bind(void 0, e);
function T(e, n) {
  const t = E(e, n.points);
  return !P(n.outcomeType) && n.points && n.points > 0 ? `+${t}` : t;
}
function E(e, n) {
  const t = { maximumFractionDigits: 2, useGrouping: !1 }, r = e.getPointsFormat(t);
  return g(n) ? r.format(n) : "";
}
function P(e) {
  return e === "Over" || e === "Under" || e === "Exactly";
}
function x(e, n) {
  e.forEach((t) => {
    const r = n.findIndex((o) => o.id === t);
    r > -1 && n.splice(r, 1);
  });
}
function q(e, n) {
  return e ?? n;
}
function H(e, n) {
  return e ? n : "";
}
function M(e) {
  const { productConfig: n, id: t, name: r, league: o, sport: i } = e;
  if (o && i && n.playerPageConfig.isEnabled && t) {
    const u = `${r}-odds-${t}`.replace(/\s/g, "-"), a = encodeURIComponent(u);
    return `/players/${i}/${o}/${a}`.toLowerCase();
  }
  return "";
}
function W(e) {
  return e.name === "AbortError";
}
export {
  l as EVENT_STATES,
  v as addTrailingSlash,
  h as areArraysEqual,
  $ as createDebouncer,
  b as delay,
  A as disposer,
  I as encodeLink,
  M as generatePlayerURL,
  L as getArray,
  y as getDefaultValue,
  N as getErrorDescription,
  d as getLiveStatistics,
  R as getLogoUrl,
  T as getPointsFormatted,
  f as getPreLiveStatistics,
  w as getStatistics,
  D as getSubArray,
  C as getSwappedValues,
  k as getTeamLogoUrlByTeamId,
  U as getTimeoutsGenerator,
  S as getTruthyValue,
  F as hasAnyPrePacks,
  p as hasLivePrePacks,
  m as hasPreLivePrePacks,
  B as hasSgpToggle,
  c as hasTag,
  W as isAbortError,
  O as isDefined,
  G as isErrorType,
  g as isNumberOrString,
  V as mapArrayElement,
  _ as pointsFormatBuilder,
  x as removeByIds,
  q as resolveDependency,
  H as tryGetClassName
};
